import axios from "axios";
import { makeAutoObservable, toJS } from "mobx";
import Tool from "../pages/ROI/Tool";
import ToolStore from "./ToolStore";

class ConversionStatisticsStore {
  defaultsValues = {};
  data = {};
  changed = {};
  reset() {
    this.defaultsValues = {};
    this.data = {};
    this.changed = {};
  }
  constructor() {
    makeAutoObservable(this);
  }

  setDefaultsValues() {
    this.defaultsValues = this.toFormatJson();
  }
  getData() {
    return toJS(this.data);
  }

  setData(values) {
    this.data = values;
  }
  setChanged(values) {
    this.changed = values;
  }

  setChangedFirst(values) {
    this.changed = values;
  }
  toFormatChanged() {
    var json = {
      rateLead: false,
      caseAcceptance: false,
    };

    return json;
  }
  toFormatJson() {
    var json = {
      rateLead: toJS(this.data)[0].value[0].value,
      caseAcceptance: toJS(this.data)[0].value[1].value,
    };

    return json;
  }
  toUpdateConversion(newValues) {
    const selected = toJS(this.data)[0];
    if (selected.value[0].value != newValues["rateLead"]) {
      selected.value[0].changed = true;
    }
    selected.value[0].value = newValues["rateLead"];
    if ((selected.value[1].value = newValues["caseAcceptance"])) {
      selected.value[1].changed = true;
    }
    selected.value[1].value = newValues["caseAcceptance"];
    this.data[0] = selected;
    this.toUpdateParent();
  }

  toUpdateParent() {
    ToolStore.toUpdate("conversionStatistics", this.getData());
  }
}

export default new ConversionStatisticsStore();
